import axios from "axios";

export const login = (body) => {
  return axios.post("/api/1.0/authorization-tokens", body);
};

export const logout = () => {
  return axios.delete("/api/1.0/authorization-tokens");
};
